import { formatDateWithSeconds } from '@/utils/date';
import {
    clampTooltipPosition,
    PROGRESS_THUMBNAIL_PADDING,
} from '@/utils/video-player';

const TOOLTIP_WIDTH = 150;

interface VideoProgressBarTimestampProps {
    hoveredTime: number;
    mouseX: number;
    progressBarWidth: number;
    earliestTimestamp: number;
}

export function VideoProgressBarTimestamp({
    hoveredTime,
    mouseX,
    progressBarWidth,
    earliestTimestamp,
}: VideoProgressBarTimestampProps) {
    const absoluteTimestamp = earliestTimestamp + hoveredTime;
    const formattedTime = formatDateWithSeconds(absoluteTimestamp);

    const leftPosition = clampTooltipPosition(
        mouseX,
        TOOLTIP_WIDTH,
        progressBarWidth,
        PROGRESS_THUMBNAIL_PADDING,
    );

    return (
        <div
            className="absolute bottom-full mb-1 pointer-events-none"
            style={{
                left: `${leftPosition}px`,
                width: `${TOOLTIP_WIDTH}px`,
            }}
        >
            <span className="block text-center text-white-100 text-xs font-geist whitespace-nowrap drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                {formattedTime}
            </span>
        </div>
    );
}
